<template>
    <div>
        <v-form ref="form" lazy-validation>
            <v-row>
                <v-col cols="12">
                    <v-radio-group v-model="updateOption" column class="mt-n2" hide-details>
                        <v-radio value="KEEP" label="Garder" color="blue"/>
                        <v-radio value="ERASE" label="Remplacer" color="red"/>
                        <v-radio value="SUM" label="Cumuler" color="teal"/>
                    </v-radio-group>
                </v-col>
                <v-col cols="12">
                    <v-btn
                        block
                        depressed
                        dark
                        color="teal"
                        :loading="loading"
                        @click="save"
                    >
                        Importer
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
import {ref} from "vue";
import {usePaySlipStore} from "@/stores/PaySlip";
import useTools from "@/use/Tools";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export default {
    props: {
        filter: Object,
        workers: Array,
        annexId: Number,
    },
    setup(props) {
        const loading = ref(false);
        const updateOption = ref('KEEP');
        const paySlipStore = usePaySlipStore();
        const {$refs} = useTools();
        const {getBack, transformFilterValues} = useSharedMethod();

        function save() {
            if ($refs.form.validate()) {
                loading.value = true;
                const ids = props.workers.map((w) => w.id);
                const body = {
                    ids: ids,
                    annexId: props.annexId,
                    updateOption: updateOption.value
                };
                axios.put(`/payments/addEvaluationPerformancePaySections`, body, {
                    params: transformFilterValues(props.filter),
                }).then(response => {
                    paySlipStore.updateAll(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        return {
            loading,
            updateOption,
            save,
        }
    }
};
</script>